export default {
  meta: {
    title: '三方对接管理'
  }
};
